import React, { useState, useEffect, useCallback, useRef } from 'react'

import { Toast, Modal } from 'antd-mobile'

import { Controlled as ControlledZoom } from 'react-medium-image-zoom'
import {getEditStudentImgServerUrl, getFileInfo} from '../../util/urlCreator'
import 'react-medium-image-zoom/dist/styles.css'
import SignDlg from '../../signDlg'
import Dialog from '@/components/dialog'
import { delImage } from '@/service/student/index'
import { EnumFileType } from '../../data'
import { EnumCacheStrategy } from '@/utils/enumer'

import {
  checkFileExist,
  sycPassportPhotoToHeadPhoto,
} from '@/service/student/index'
import { getImageFile } from '@/service/sign'

import DelSVG from '@/static/images/del.svg'
import ZoomSVG from '@/static/images/zoom.svg'
import './center.css'
import 'isigning-open/esm/styles.less'

/**
 * 通用签字 TODO: 后端和产品确定每种文件都签一次
 * 签字由标品控件上传，这里接收处理后的结果
 * @param props
 * @returns
 */
function UsualSign(props: Picture.UploadFile ): JSX.Element {
  console.log('reload UsualSign', props)
  const { defaultImg, text, type, steps, submitUrl, tempFile, studentId, avatarSource, itemImgChange } = props
  const [img, setImg] = useState(defaultImg)
  const [fileId, setFileId] = useState(props.fileId)
  const [isZoomed, setIsZoomed] = useState(false)

  const dlgSign = useRef(null)

  const handleZoomChange = useCallback(shouldZoom => {
    setIsZoomed(shouldZoom)
  }, [])

  useEffect(() => { // change & destory
    if(fileId) {
      loadImg(fileId)
    }
    return () => {
      console.log('image change and dlg close', dlgSign)
      dlgSign.current && dlgSign.current.close()
    }
  }, [img])

  // 之前有多张背景，所以用了列表。现在只有单张背景默认图
  const cameraList = () => {
    const _zoom = {
      isZoomed: isZoomed,
      onZoomChange: handleZoomChange,
      overlayBgColorStart: 'rgba(0, 0, 0, 0)',
      overlayBgColorEnd: 'rgba(0, 0, 0, 0.5)',
    }

    return img !== null ?
      <ControlledZoom {..._zoom}><img className="center-img" src={img} key={img} alt={text} /></ControlledZoom> : null
  }

  // 加载图片
  const loadImg = (fileId?: string) => {
    let src:string
    if(!fileId) {
      src = getEditStudentImgServerUrl(type);
    } else {
      src = getFileInfo(fileId)
    }
    setImg(src)
  }

  // 选择拍照还是签字的图片, 不是拍照就是签字
  const renderFlag = () => {
    return fileId ? null : <div className="sign-flag" />
  }

  // 删除图片按钮
  const deleteImg = () => {
    delImage({
      fileType: type,
      studentId
    }).then(() => {
      setFileId('')
      setImg(defaultImg)
      itemImgChange(type, '')
    })
  }

  // 查看图片按钮
  const imgZoom = () => {
    setIsZoomed(true)
  }

  // 获取文件模板
  const getImgTemp = () => {
    let _url = `${tempFile}?`;
    if (tempFile.indexOf('?') > -1) {
      _url = `${tempFile}&`;
    }
    _url = _url + `studentId=${studentId}&_token=${localStorage.getItem('token')}`;
    getImageFile(_url).then((res) => {
      const fileStr = `data:image/png;base64,${res.data}`
      dlgSign.current = showDialog(fileStr)
    })
  }

  const showDialog = (fileStr) => {

    const params = {
      fileStr,  // 签字这里是模板地址
      // n次拍摄时显示的标题, 子组件依赖此判断步骤次数
      type,
      steps: steps,
      fileIndex: 0,  // 图片索引，多次拍摄时，确定更新的位置, 0 开始
      studentId,
      submitUrl: submitUrl,  // 上传地址
      onSave: (fileId: string) => { // 拍摄完成
        dlgSign.current && dlgSign.current.close()
        setFileId(fileId)
        loadImg(fileId)
        itemImgChange(type, fileId)
      }
    }
    return Dialog(<SignDlg {...params} />)
  }

  // 检测制证照或头像是否上传
  const checkFile = () => {
    if (avatarSource) {
      checkFileExist({
        fileType: EnumFileType.证件照,
        studentId,
        cache: EnumCacheStrategy.只获取缓存
      }).then((res) => {
        if (!res.data) {
          Toast.info('请先上传证件照后再签字');
        } else {
          sycPassportPhotoToHeadPhoto({ studentId }).then(() => {
            getImgTemp()
          })
          // const alert = Modal.alert(
          //   '提示',
          //   '还未上传电子头像，是否需要把制证照同步到电子头像?',
          //   [
          //     {
          //       text: '取消', onPress: () => {
          //         alert.close()
          //         Modal.alert('', '请上传电子头像后再完成签名');
          //       }, style: 'default'
          //     },
          //     {
          //       text: '确定', onPress: () => {
          //         sycPassportPhotoToHeadPhoto({ studentId }).then(() => {
          //           getImgTemp()
          //         })
          //       }
          //     },
          //   ]
          // );
        }
      })
    } else {
      checkFileExist({
        fileType: EnumFileType.身份证电子照片,
        studentId,
        cache: EnumCacheStrategy.只获取缓存
      }).then((res) => {
        if (!res.data) {
          checkFileExist({
            fileType: EnumFileType.证件照,
            studentId,
            cache: EnumCacheStrategy.只获取缓存
          }).then(resType15 => {
            if (resType15.data) {
              sycPassportPhotoToHeadPhoto({ studentId }).then(() => {
                getImgTemp()
              })
              // const alert = Modal.alert(
              //   '提示',
              //   '还未上传电子头像，是否需要把制证照同步到电子头像?',
              //   [
              //     {
              //       text: '取消', onPress: () => {
              //         alert.close()
              //         Modal.alert('', '请上传电子头像后再完成签名');
              //       }, style: 'default'
              //     },
              //     {
              //       text: '确定', onPress: () => {
              //         sycPassportPhotoToHeadPhoto({ studentId }).then(() => {
              //           getImgTemp()
              //         })
              //       }
              //     },
              //   ]
              // );
            } else {
              Modal.alert('', '请上传电子头像后再完成签名');
            }
          })
        } else {
          getImgTemp()
        }
      })
    }

  }

  // 处理组件流程
  const operType = () => {
    if(!fileId) {
      if (type === EnumFileType.驾驶证申请表) {
        checkFile()
      } else {
        getImgTemp()
      }
    }
  }

  // 构造处理区域, 按钮组等
  const renderOperArea = () => {
    const operBtns = [
      <a key="zoom" className="oper-btn oper-zoom" onClick={() => imgZoom()}><img className="oper-img" src={ZoomSVG} alt="放大" /><span className="oper-txt">放大</span></a>,
      <a key="del" className="oper-btn oper-del" onClick={() => deleteImg()}><img className="oper-img" src={DelSVG} alt="删除" /><span className="oper-txt">删除</span></a>
    ]

    if (fileId) {
      return operBtns
    }  else {
      return null
    }
  }

  return (
    <>
      <div className="imgload-bg" onClick={operType}>
        <div className="flex-center">
          <div className="block">
            {cameraList()}
            {renderFlag()}
          </div>
          {!fileId ? <span className="bg-txt">{text}</span> : null}
        </div>
      </div>
      <div className="oper-area">
        {renderOperArea()}
      </div>
    </>
  )
}

export default UsualSign
